
import React, { createContext, useContext, useState, useEffect, } from 'react';
import { getAuth, onAuthStateChanged, signOut, updatePassword, reauthenticateWithCredential, EmailAuthProvider  } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';

import UserMenu from '../UserMenu/UserMenu';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // Menu open/close state
    const navigate = useNavigate(); 
    const location = useLocation();
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = () => {
        signOut(auth).then(() => {
            setUser(null); // Logout ho gaya hai, user ko null set karna
            setIsMenuOpen(false); // Menu ko close karna
            navigate('/login'); // Redirect to login after logout
        });
    };


    const handleUserNavigation = () => {
        if (user) {
            setIsMenuOpen(!isMenuOpen); // UserMenu ko toggle karna
        } else {
            navigate('/login', { state: { from: location.pathname } }); // Redirect to Login if user is not logged in
        }
    };

    const closeMenu = () => {
        setIsMenuOpen(false); // Close the menu
      };

      // 🔹 Function to update user password
//   const updateUserPassword = async (oldPassword, newPassword) => {
//     if (!user) {
//       throw new Error("User not authenticated.");
//     }

//     const credential = EmailAuthProvider.credential(user.email, oldPassword);

//     try {
//       // Re-authenticate user
//       await reauthenticateWithCredential(user, credential);

//       // Update password
//       await updatePassword(user, newPassword);
//       return "Password changed successfully!";
//     } catch (error) {
//       throw new Error(error.message);
//     }
//   };

const updateUserPassword = async (oldPassword, newPassword) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User is not logged in.");
  }

  try {
    // Reauthenticate user with old password
    const credential = EmailAuthProvider.credential(user.email, oldPassword);
    await reauthenticateWithCredential(user, credential);

    // If reauthentication is successful, update the password
    await updatePassword(user, newPassword);
    return "Password changed successfully!";
  } catch (error) {
    if (error.code === "auth/invalid-credential") {
      throw new Error("Old password is incorrect.");
    }
    throw new Error("Failed to change password. Try again later.");
  }
};


    return (
        <AuthContext.Provider value={{ user, handleUserNavigation, closeMenu, updateUserPassword }}>
            {children}
            {isMenuOpen && <UserMenu onLogout={handleLogout} />} {/* UserMenu only shown if user is logged in */}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);


// import React, { createContext, useContext, useState, useEffect, } from 'react';
// import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import { useNavigate, useLocation } from 'react-router-dom';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null);
//     const navigate = useNavigate(); 
//     const location = useLocation();
//     const auth = getAuth();

//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//             setUser(currentUser);
//         });
//         return () => unsubscribe();
//     }, []);

//     const handleUserNavigation = () => {
//         if (user) {
//             navigate('/receipt'); // Redirect to Receipt if user is logged in
//         } else {
//             navigate('/login', { state: { from: location.pathname } }); // Redirect to Login if user is not logged in
//         }
//     };

//     return (
//         <AuthContext.Provider value={{ user, handleUserNavigation }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export const useAuth = () => useContext(AuthContext);
